module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_7.a07c5564.png";